import { Card } from "@blueprintjs/core";
import { useMemo } from "react";

type HeaderCreateEditProps = {
  loading: boolean;
  title: string;
  name?: string | null;
  editing: boolean;
};

export function HeaderCreateEdit({
  editing,
  loading,
  name = "Unknown",
  title,
}: HeaderCreateEditProps) {
  const display = useMemo<string>(
    () =>
      editing
        ? `${title} Edit: ${loading ? "Loading..." : name}`
        : `Create New ${title}`,
    [editing, loading, name, title],
  );

  return (
    <Card compact elevation={1}>
      <h4 className="m-0 content-center bp6-heading">{display}</h4>
    </Card>
  );
}
